import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import { Button, DialogContent, IconButton } from "@material-ui/core";
import api from '../../../store/api';
import { RadioProps } from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from "react-hook-form";
import StyledRadio from './StyledRadio';

interface PopupProps extends RadioProps {
    popState: any[],
    abortTransfer: any,
    transferId: string
};

interface IAbortReasons {
    deleted: any,
    name: string,
    reasonForAbortId: string
}

const useStyles = makeStyles(() => ({
    labelAbort: {
        fontSize: 18,
        fontWeight: 400,
        color: "#14191C",
    },
    commentsInput: {
        "&::placeholder": {
            color: "#14191C",
            opacity: 0.4,
        },
        color: "#14191C",
    },
}));

const Popup: React.FC<PopupProps> = ({ 
    popState, 
    abortTransfer, 
    transferId }) => {
    const classes = useStyles();
    const [abortReasons, setAbortReasons] = React.useState<IAbortReasons[]>([]);
    const { handleSubmit, errors, control, getValues } = useForm();

    React.useEffect(() => {
        api.getReasonsToAbort("").then((res) => {
            if (res?.data?.model) {
                setAbortReasons(res.data.model);
            }
        }).catch((err) => {
        });
    }, [])

    const handleNext = async () => {
        const { reasonForAbortId, reasonForAbortNote } = getValues();
        await abortTransfer(transferId, reasonForAbortId, reasonForAbortNote)
        popState[1](false);
    }

    return (
        <Dialog
            open={popState[0]}
            PaperProps={{
                style: {
                    backgroundColor: "#FFF",
                },
            }}
            onClose={() => popState[1](false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="xs"
        >
            <DialogContent
                style={{
                    width: 360,
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography style={{ color: "#14191C", fontWeight: 400, fontSize: 19 }} gutterBottom>
                        Abort Transfer
                    </Typography>
                    <IconButton style={{ padding: 0 }} onClick={() => popState[1](false)} aria-label="close">
                        <CloseIcon style={{ color: "#000" }} />
                    </IconButton>
                </div>
            </DialogContent>
            {/* <div style={{ height: 1, backgroundColor: "#979797" }}></div> */}
            <form onSubmit={handleSubmit(handleNext)}>
                <DialogContent
                    style={{
                        width: 360,
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >

                        <Typography style={{ color: "#14191C", fontWeight: 800, fontSize: 18 }} gutterBottom>
                            Why are you aborting this transfer?
                        </Typography>
                        <div style={{ display: "flex", width: "100%" }}>
                            <Controller name="reasonForAbortId" defaultValue="" rules={{ required: true }} control={control} as={
                                <RadioGroup aria-label="abort-radio" name="abort-radio">
                                    {abortReasons.map((item) => (
                                        <FormControlLabel classes={{ label: classes.labelAbort }} value={item.reasonForAbortId} control={<StyledRadio />} label={item.name} />
                                    ))}
                                    {/* <FormControlLabel classes={{label: classes.labelAbort}} value="Reason related to patient" control={<StyledRadio />} label="Reason related to patient" />
                    <FormControlLabel classes={{label: classes.labelAbort}} value="Clinical incident" control={<StyledRadio />} label="Clinical incident" />
                    <FormControlLabel classes={{label: classes.labelAbort}} value="Reason related to SMA delivery" control={<StyledRadio />} label="Reason related to SMA delivery" /> */}
                                </RadioGroup>
                            } />
                        </div>
                        <Controller
                            name="reasonForAbortNote"
                            defaultValue=""
                            control={control}
                            as={<TextField
                                size="small"
                                variant="outlined"
                                rows="5"
                                InputProps={{
                                    rows: "5",
                                    placeholder: "Comments...",
                                    style: { backgroundColor: "#ECECEC" },
                                    classes: { input: classes.commentsInput },
                                }}
                                style={{ marginTop: 10 }}
                            />}
                            rules={{
                                required: true
                            }}
                        />
                    </div>
                    {/* {errors.reasonForAbortId || errors.reasonForAbortNote} */}
                    <Typography style={{ color: "#FF191C", fontWeight: 400, fontSize: 12 }} gutterBottom>
                        {(errors.reasonForAbortId?.type === "required" && "Please select aborting reason.") || (errors.reasonForAbortNote?.type === "required" && "Comments are required.")}
                    </Typography>
                </DialogContent>
                {/* <div style={{ height: 1, backgroundColor: "#979797" }}></div> */}
                <DialogContent
                    style={{
                        width: 360,
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        overflow: "hidden",
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 15, marginTop: 15 }}>
                        <Button
                            style={{
                                width: 163,
                                height: 44,
                                background: "#ECECEC",
                                color: "#03090E",
                                textTransform: "none",
                                fontWeight: 700,
                                fontSize: 19,
                            }}
                            variant="contained"
                            color="primary"
                            disableElevation
                            onClick={() => popState[1](false)}
                        >
                            Cancel
                        </Button>
                        <Button style={{ width: 163, height: 44, background: "#02489D", textTransform: "none", fontWeight: 700, fontSize: 19 }} variant="contained" color="primary" disableElevation type="submit">
                            Apply
                        </Button>
                    </div>
                </DialogContent>
            </form>
        </Dialog>
    );
};

export default Popup;